module.exports = __webpack_public_path__ + "static/profile-749f9bdab9330f35d3778d952a47a12c.png";